<app-base-list-wrapper [baseListComponent]="this">
    <ng-template #preColHeaders let-data>
        <th [width]="100">Icons</th>
    </ng-template>
    <ng-template
        #preCols
        let-rowData="rowData"
        let-rowIndex="rowIndex"
        let-editing="editing"
        let-table="table"
    >
        <td>
            <div style="text-align: center" class="link-primary">
                <i
                    *ngIf="rowData.isFavorite"
                    pTooltip="{{ 'common.favorite' | translate }}"
                    class="fa fa-star fa-lg"
                    style="margin-left: 2pt"
                ></i>
            </div>
        </td>
    </ng-template>
</app-base-list-wrapper>
